query getDeadlines($site: [String!], $now: [QueryArgument!]) {
    entries(
        site: $site,
        section: "periods",
        plainDate2: $now,
        orderBy: "plainDate2 ASC"
    ) {
        id
        ... on default_Entry {
            deadline: plainDate2 @formatDateTime(format: "c", timezone: "Europe/Amsterdam")
            phase: plaintext
        }
    }
}
